export enum RangeModeTypes {
  Day = "DAY",
  Week = "WEEK",
  TwoWeeks = "TWO_WEEKS",
  Month = "MONTH",
  Quarter = "QUARTER",
  Custom = "CUSTOM"
}
